import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { useUserData } from '@nhost/react'

export default function UserInfo() {
  const userData = useUserData()

  const roles = userData?.roles || []

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between p-6">
        <CardTitle>User Roles</CardTitle>
      </CardHeader>
      <CardContent>
        {roles.length > 0 ? (
          <ul>
            {roles.map((role, index) => (
              <li key={index}>{role}</li>
            ))}
          </ul>
        ) : (
          <p>No roles found</p>
        )}
      </CardContent>
    </Card>
  )
}
